import { OnboardingFormState } from '../../../types/state'
import { setNewCompanies } from './setNewCompanies'

export const getStateAfterLicenseRemoved = ({
  currentState,
  licenseIndex,
  companyIndex
}: {
  currentState: OnboardingFormState
  licenseIndex: number
  companyIndex: number
}) => {
  const selectedCompany = currentState.formValue.companiesFormValues[companyIndex]
  const oldLicenses = selectedCompany.licenses

  const newLicenses = oldLicenses.filter((_, index) => index !== licenseIndex)
  const newCompany = { ...selectedCompany, licenses: newLicenses }
  const newCompaniesFormValues = setNewCompanies({
    companyIndex,
    oldCompanies: currentState.formValue.companiesFormValues,
    newCompany
  })

  return {
    selectedCompany: newCompany,
    formValue: {
      ...currentState.formValue,
      companiesFormValues: newCompaniesFormValues
    }
  }
}
